"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValidColorPalette = exports.DEFAULT_BULLET_GRAY_COLOR = exports.DEFAULT_HEATMAP_BLUE_BASE_COLOR = exports.DEFAULT_HEATMAP_BLUE_COLOR = exports.HEATMAP_BLUE_COLOR_PALETTE = exports.TRANSPARENT = exports.AXIS_LINE_COLOR = exports.GRAY = exports.BLACK = exports.WHITE = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sdk_ui_vis_commons_1 = require("@gooddata/sdk-ui-vis-commons");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
exports.WHITE = "rgb(255, 255, 255)";
exports.BLACK = "rgb(0, 0, 0)";
exports.GRAY = "rgb(201, 213, 223)";
exports.AXIS_LINE_COLOR = "#d5d5d5";
exports.TRANSPARENT = "transparent";
exports.HEATMAP_BLUE_COLOR_PALETTE = [
    "rgb(255,255,255)",
    "rgb(197,236,248)",
    "rgb(138,217,241)",
    "rgb(79,198,234)",
    "rgb(20,178,226)",
    "rgb(22,151,192)",
    "rgb(0,110,145)",
];
exports.DEFAULT_HEATMAP_BLUE_COLOR = { r: 0, g: 110, b: 145 };
exports.DEFAULT_HEATMAP_BLUE_BASE_COLOR = { r: 20, g: 178, b: 226 };
exports.DEFAULT_BULLET_GRAY_COLOR = {
    r: 217,
    g: 220,
    b: 226,
};
/**
 * @internal
 */
function getValidColorPalette(config) {
    return isEmpty_1.default(config.colorPalette)
        ? isEmpty_1.default(config.colors)
            ? sdk_ui_1.DefaultColorPalette
            : sdk_ui_vis_commons_1.getColorPaletteFromColors(config.colors)
        : config.colorPalette;
}
exports.getValidColorPalette = getValidColorPalette;
//# sourceMappingURL=color.js.map